export const getUserPermissions = () => {
  if (typeof window === 'undefined') return []
  const permissions = localStorage.getItem('userPermissionsKeys')

  return permissions ? JSON.parse(permissions) : []
}

export const isTheActionPermitted = (appName) => {
  let found = false
  if (typeof window === 'undefined') return []
  const rolesWithPermissionData = localStorage.getItem('rolesWithPermissions')
  const rolesWithPermissions = JSON.parse(rolesWithPermissionData) || []
  const isOwner = rolesWithPermissions?.find(
    (role) => role?.name?.toLowerCase() === 'owner'
  )
  if (isOwner) {
    return true
  }

  const permissions = getUserPermissions()

  const appPermission = permissions?.find((p) => p.appName === appName)
  if (appPermission) {
    found = true
  }

  return found
}

export const hasAnyPermission = (appName, permissionName) => {
  if (typeof window === 'undefined') return []
  const rolesWithPermissionData = localStorage.getItem('rolesWithPermissions')
  const rolesWithPermissions = JSON.parse(rolesWithPermissionData) || []
  const isOwner = rolesWithPermissions?.find(
    (role) => role?.name?.toLowerCase() === 'owner'
  )
  if (isOwner) {
    return true
  }
  const permissions = getUserPermissions()
  const appPermission = permissions.find((p) => p.appName === appName)
  if (!appPermission) return false
  const permissionsList =
    appPermission.permissionName?.map((item) => item) || []
  return permissionsList.includes(permissionName)
}
